import { render, staticRenderFns } from "./checkClubVerifyCode.vue?vue&type=template&id=c2a28850&scoped=true&"
import script from "./checkClubVerifyCode.vue?vue&type=script&lang=js&"
export * from "./checkClubVerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./checkClubVerifyCode.vue?vue&type=style&index=0&id=c2a28850&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a28850",
  null
  
)

export default component.exports